import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import SchoolAccessRecord from "../../models/SchoolAccessRecord";
import {
    ActionButton, CommandBarButton,
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType, Icon,
    MessageBarType,
    PrimaryButton
} from "office-ui-fabric-react";
import Actions from "../../redux/Actions";
import ApiService from "../ApiService";
import {
    Client as GraphClient,
} from "@microsoft/microsoft-graph-client";

import * as H from "history";
import Table, {TableColumn} from "../Table";
import * as _ from 'lodash';
import TableCell from "../TableCell";
import {Link} from "react-router-dom";
import School from "../../models/School";
import LoadingPage from '../LoadingPage';
import SchoolMenu from '../SchoolMenu';
import SchoolPageTitle from '../SchoolPageTitle';

interface GraphUser
{
    displayName: string;
    userPrincipalName: string;
}

interface ListSchoolAccessRecordsPageProps {
    
    tenantId: string;
    schoolCode: string;
    
    
    history: H.History,
    user: any,
    
    graphClient: GraphClient;
    apiService: ApiService;

    userIsCdbEmployee: boolean;

}

interface ListSchoolAccessRecordsPageState {
    school?: School;
    loading?: boolean;
    showDeleteDialog: boolean;
    accessRecordsWithUsers: {accessRecord: SchoolAccessRecord,user?: GraphUser }[];
    accessRecordToDelete?: {accessRecord: SchoolAccessRecord,user?: GraphUser};
}

class ListSchoolAccessRecordsPage extends Component<ListSchoolAccessRecordsPageProps & DispatchProps ,ListSchoolAccessRecordsPageState> {
    static displayName = ListSchoolAccessRecordsPage.name;
    
    public static buildHelpBox(): JSX.Element
    {
        return (
            <div className={"flex-row flex--justify-content-center p-top-1rem"}>
                <div className="help-box-item help-box-item--wide">
                    <div className="help-box-item__icon">
                        <Icon iconName="Signin" className=""/>
                    </div>
                    <span className="help-box-item__title">Manage School access</span>
                    <span className="help-box-item__description">
                        <span>School Managers can create sites, manage school access, manage class drop ins and view whole school assignment analytics.</span>
                        <br/>
                        <br/>
                        <span>School Leaders can manage class drop ins and view whole school assignment analytics.</span>
                    </span>
                </div>
            </div>
        );
    }
    
    private static columns: TableColumn[] = [
        {
            title: "User",
            propertyPath: "userOid",
            flex: 1
        },
        {
            title: "Level",
            propertyPath: "level",
            flex: 1
        },
        {
            title: "",
            propertyPath: "delete",
            flex: 1
        }
    ]; 

    constructor(props: ListSchoolAccessRecordsPageProps & DispatchProps) {
        super(props);

        this.state = {
            showDeleteDialog: false,
            accessRecordsWithUsers: [],
            accessRecordToDelete: undefined
        }
    }
    
    private async load() {
        this.setState({ loading: true });

        try {
            const accessRecords = await this.props.apiService.getAccessRecordsForSchool(this.props.tenantId, this.props.schoolCode);

            await this.searchUsersAndSetState(accessRecords);
        }
        catch (e)
        {
            this.props.dispatch(Actions.showMessageBar(`Error getting access records: ${e.message}`, MessageBarType.error));
        }

        const school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode);

        this.setState({
            school,
            loading: false
        });
    }

    async searchUsersAndSetState(accessRecords: SchoolAccessRecord[]) {
        const userDict: { [key: string]: GraphUser } = {};

        const userOids = accessRecords.map(ar => ar.userOid!);
        const userOidChunks = _.chunk(userOids, 15);

        for (const userOidChunk of userOidChunks) {
            const filterConditions = userOidChunk.map(userOid => `id eq '${userOid}'`);
            const filter = _.join(filterConditions, ' or ');

            let result: any;

            if (this.props.userIsCdbEmployee) {
                result = await this.props.apiService.searchGraphUsersAdmin(this.props.tenantId, filter);
            }
            else {
                const search = await this.props.graphClient.api("/users").filter(filter).get();
                result = search.value;
            }

            const users = _.keyBy(result, "id");

            Object.assign(userDict, users);
        }

        const accessRecordsWithUsers = accessRecords.map(accessRecord => {
            return {
                accessRecord,
                user: userDict[accessRecord.userOid!]
            };
        })

        this.setState({
            accessRecordsWithUsers: _.sortBy(accessRecordsWithUsers, "user.displayName")
        });
    }

    async componentDidMount() {
        if(this.props.tenantId || this.props.schoolCode)
        {           
            await this.load();
        }
    }

    async componentDidUpdate(prevProps: Readonly<ListSchoolAccessRecordsPageProps & DispatchProps>, prevState: any): Promise<void> {
        
        if(this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode)
        {          
            await this.load();
        }
    }
    
    async deleteSchoolManager() {
        
        if(this.state.accessRecordToDelete)
        {
            await this.props.apiService.deleteAccessRecord(this.state.accessRecordToDelete!.accessRecord);
            
            const deletingSelf = this.props.user.idTokenClaims.oid === this.state.accessRecordToDelete.accessRecord.userOid;
            
            this.setState({
                showDeleteDialog: false,
                accessRecordToDelete: undefined
            });
            
            if(deletingSelf)
            {
                await this.props.history.push('/');
            }
            else 
            {
                await this.load();
            }
        }
        
    }
    
    private cellForColumn = (item: {accessRecord: SchoolAccessRecord,user?: GraphUser},column: TableColumn,index: number) => {
        
        let content = null;
        if(column.propertyPath === "userOid")
        {
            if(item.user)
            {
                content = (
                    <Fragment>
                        <span>{item.user.displayName}</span>
                        <span className={"cdb-table__extra-detail"}>{item.user.userPrincipalName}</span>
                    </Fragment>
                );
            }
            else
            {
                content = (<span>{item.accessRecord.userOid}</span>);
            }
        }
        else if(column.propertyPath === "delete")
        {
            content = (
                <ActionButton iconProps={{iconName: "Delete"}} allowDisabledFocus disabled={false} checked={false} onClick={() => {

                    this.setState({
                        showDeleteDialog: true,
                        accessRecordToDelete: item
                    });
                }}>
                    Remove
                </ActionButton>
            );
        }
        else
        {
            content = item.accessRecord[column.propertyPath];
        }
        
        return (
            <TableCell key={index} flex={column.flex}>
                {content}
            </TableCell>
        );
        
    };

    private renderContent() {
        if (this.state.loading) {
            return <LoadingPage />
        }
        else {
            return <Fragment>
                {ListSchoolAccessRecordsPage.buildHelpBox()}

                <Table
                    title={"School Access"}
                    items={this.state.accessRecordsWithUsers}
                    columns={ListSchoolAccessRecordsPage.columns}
                    cellForColumn={this.cellForColumn}>
                    <Link to={`/manage/${this.props.tenantId}/${this.props.schoolCode}/school-access/add`}>
                        <CommandBarButton
                            iconProps={{ iconName: "add" }}
                            text="Add"
                            onClick={() => { }}
                        />
                    </Link>
                </Table>

                <Dialog
                    hidden={!this.state.showDeleteDialog}
                    onDismiss={() => {
                        this.setState({
                            showDeleteDialog: false
                        });
                    }}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: 'Remove Access',
                        subText: `Do you want to remove access for ${this.state.accessRecordToDelete?.user?.userPrincipalName}?`
                    }}
                    modalProps={{
                        isBlocking: false,
                        styles: { main: { maxWidth: 900 } },
                    }}>
                    <DialogFooter>
                        <PrimaryButton onClick={async () => {
                            await this.deleteSchoolManager();
                            this.setState({
                                showDeleteDialog: false,
                            });
                        }} text="Remove" />
                        <DefaultButton onClick={() => {
                            this.setState({
                                showDeleteDialog: false,
                                accessRecordToDelete: undefined,
                            });
                        }} text="Cancel" />
                    </DialogFooter>
                </Dialog>
            </Fragment>
        }
    }
    
    render () {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Access Management" reverse={true} />
                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    <SchoolMenu prefix="Access"/>

                    {this.renderContent()}
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {history: H.History,match: any}): ListSchoolAccessRecordsPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
                        
            history: ownProps.history,
            user: state.auth.user!,
            graphClient: state.auth.graphClient,
            apiService: state.auth.apiService,
            userIsCdbEmployee: state.auth.userIsCdbEmployee
        };
    }
)(ListSchoolAccessRecordsPage)